<template>
  <q-section v-bind="$attrs" :key="`lottery-button-${active}-${type}`" @click="handleDoLottery(animationCallBack)"></q-section>
</template>

<script setup lang="ts">
import { useLottery } from './use-lottery'
import { defaultConfig as uiMeta } from './use-lottery'
const props = defineProps({
  animationCallBack: {
    type: Function,
    default: () => {},
  },
  // 兼容两个tab
  active: {
    type: Number,
    default: 0,
  },
  //   1抽 10抽 .... n抽
  type: {
    type: Number,
    default: 0,
  },
})

const { handleDoLottery } = useLottery(uiMeta, props.active, props.type)
</script>

<style scoped lang="scss"></style>
